import React from "react";

export default function BlogInfoPage() {
  return <div>Blog</div>;
}
